import './App.scss';
import { Route, Switch } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

import LoginPage from './components/login/loginPage';
import LandingPage from './components/home/landingPage';
import NotFound from './components/not-found/not-found';
import ResetPassword from './components/reset-password/index';
import NoAccessPage from './components/no-access/noAccess';


function AppComponent() {
  const ToastObject = (
    <ToastContainer
      position='bottom-right'
      autoClose={3000}
      hideProgressBar={true}
      closeOnClick={true}
      progress={undefined}
      transition={Flip}
      limit={5}
      className='toast-container'
      pauseOnHover
      draggable
    />
  );
  return (
    <>
      <Container fluid>
        <Switch>
          <Route path='/login' exact component={LoginPage}></Route>
          <Route path='/noAccess' exact component={NoAccessPage}></Route>
          <Route path='/reset-password' exact component={ResetPassword}></Route>
          <Route path='/not-found' exact component={NotFound}></Route>
          <Route path='/' component={LandingPage}></Route>
        </Switch>
      </Container>
      {ToastObject}
    </>
  );
}

export default AppComponent;
